<template>
	<div class="login">
		<h1 class="brand">
			<a href="index.html" v-bind:style="{ 'background-image': backgroundImage}">{{title}}</a>
		</h1>
		<div class="login-box">
			<h2>
				{{title}}<br>
				LMS 관리자 시스템
				<small>관리자 아이디로 로그인하십시오.</small>
			</h2>
			<input class="form-control full-width round m-t-15" type="text" v-model="id" ref="id" placeholder="아이디를 입력하세요.">
			<input class="form-control full-width round" type="password" v-model="passwd" ref="passwd" placeholder="비밀번호를 입력하세요." @keydown.enter="doLogin">
			<button class="btn bg-blue full-width text-white round m-t-15" type="button" ref="btnLogin" @click="doLogin">로그인</button>
		</div>

		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;"></modal-alert>
	</div>
</template>

<script>
import ModalAlert from '../modals/ModalAlert.vue'
import axios from 'axios'
import server from '../statics/server.js'
import cookie from 'js-cookie'

export default {
	// 컴포넌트 명
	name: 'ViewLogin',

	// 이 컴포넌트가 DOM에 마운트될 때, 포커스를 아이디 입력란으로 옮긴다.
	mounted: function() {
		// 엑세스토큰이 이미 존재하는지 확인
		const token = cookie.get("access_token");
		// 엑세스토큰이 이미 존재하면 유효한지 확인
		if(token) {
			this.getLoginInfo().then((response) => {
				// 엑세스토큰이 유효하면 회원관리화면으로 이동
				if(response.data && response.data.msg=="성공") {
					this.$router.push("/main")
				}
			});
		}
		this.$refs.id.focus();
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			id: "",
			passwd: "",
			title: server.logo.title,
			backgroundImage: server.logo.img,
			modals: {
				ModalAlert: ModalAlert.default()
			}
		}
	},

	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ModalAlert
	},

	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		doLogin: function() {
			// 입력값 확인
			if(!this.id.trim())
			{
				this.modals.ModalAlert.msg = "관리자 아이디를 입력하세요.";
				this.modals.ModalAlert.show = true;
				return;
			}
			if(!this.passwd.trim())
			{
				this.modals.ModalAlert.msg = "비밀번호를 입력하세요.";
				this.modals.ModalAlert.show = true;
				return;
			}
			// 로그인 버튼 비활성화
			this.$refs.btnLogin.innerText = "로그인 하는 중...";
			this.$refs.btnLogin.disabled = true;
			// 로그인 요청
			axios.post(server.addr()+"/auth/login", {
				id: this.id,
				password: this.passwd
			}).then( (response) => {
				this.setAccessToken(response.data.accessToken);
				this.$router.push("/main");
			}).catch( (error) => {
				this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
				this.modals.ModalAlert.show = true;
				this.$refs.btnLogin.innerText = "로그인";
				this.$refs.btnLogin.disabled = false;
				// eslint-disable-next-line
				console.log("ERROR", error);
			});
		}
	}
}
</script>
